import { useState } from "react";
import { IoAdd, IoClose } from "react-icons/io5";

import Modal from "../../../../../components/common/Modal";
import TableControls from "../../../../../components/common/TableControls";
import TableSize from "../../../../../components/common/TableSize";
import TextboxSearch from "../../../../../components/common/TextboxSearch";

import AccountChartFilter from "./AccountChartFilter";
import AccountChartForm from "./AccountChartForm";

const AccountChartHeader = ({ options, onChange, onSuccess }) => {
  const [showForm, setShowForm] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const settings = [
    {
      id: 1,
      content: (
        <TableSize size={options.size} onChange={(e) => handleSizeChange(e)} />
      ),
    },
  ];

  const handleSizeChange = (event) => {
    const size = event.target.value;

    if (size !== options.size) {
      const new_options = { ...options };
      new_options.size = size;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleSearch = (query) => {
    const new_options = { ...options };

    if (new_options.search_query !== query) {
      new_options.status = "";
      new_options.search_query = query;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleFilter = (type) => {
    const new_options = { ...options };
    new_options.type = type;
    onChange(new_options);
    setShowFilter(false);
  };

  const handleRemoveFilter = (item) => {
    const new_options = { ...options };
    if (item === 1) new_options["type"] = "";
    onChange(new_options);
  };

  return (
    <>
      <div className="block lg:flex justify-between items-center">
        <div>
          <p className="text-gray-500 dark:text-gray-300">Account Charts</p>
          <span className="text-gray-400 text-xs">
            Configure chart of accounts
          </span>
        </div>
        <div className="mt-5 lg:mt-0 block md:flex md:space-x-2">
          <TextboxSearch
            width="md:w-52"
            placeholder="Search..."
            onSearch={handleSearch}
          />
          <TableControls
            onFilter={() => setShowFilter(true)}
            settings={settings}
          />
          <button
            className="button button-primary mt-2 md:mt-0"
            onClick={() => setShowForm(true)}
          >
            <IoAdd className="mr-2" />
            Account Chart
          </button>
        </div>
      </div>
      <div className="mt-1 float-right">
        <div className="flex gap-2">
          {options.type !== "" && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              {options.type}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(1)}
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        title="Create Account Chart"
        isOpen={showForm}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <AccountChartForm
          isLoading={isLoading}
          setLoading={setIsLoading}
          setShowForm={setShowForm}
          onSuccess={onSuccess}
        />
      </Modal>
      <Modal
        title="Filter"
        isOpen={showFilter}
        onClose={() => setShowFilter(false)}
        borderTop
      >
        <AccountChartFilter options={options} onFilter={handleFilter} />
      </Modal>
    </>
  );
};

export default AccountChartHeader;
